import React from "react"
// import ReactPlayer from 'react-player'
import VideoWrapper from '../ui/VideoWrapper'

const Video = ({input, autoplay}) => {
  return (
    <section className="section section-video ssss">
			<div className="container-fluid">
        <div className="row">
          <div className="col-xs-12">
            <VideoWrapper input={input.embed} autoplay={autoplay} />
          </div>
        </div>
        <div className="row">
          <div className="hidden-xs col-md-2"></div>
          {input.texte &&
              <div className="col-xs-12 col-md-4">
                <div
                  className="texte "
                  dangerouslySetInnerHTML={{
                    __html: input.texte.html,
                  }} ></div>
              </div>
            }  
          <div className="hidden-xs col-xs-12 col-md-6"></div> 
        </div>
			</div>
		</section>
  );
};

export default Video;